import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const CarimboAcessorios = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Carimbos";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.carimboAcessorios})` }}>
        <div className="servico-hero-overlay">
          <h1>Carimbos</h1>
          {/*<p>Para quem procura por carimbos e acessórios</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Carimbos e Acessórios */}
        <section className="acessorios-grid">
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.tintasAlmofadas} alt="" /></div>
            <h3>Automáticos</h3>
            <p>Com tinta interna para uso contínuo.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.carimbosBolso} alt="" /></div>
            <h3>Bolso</h3>
            <p>Modelos compactos para transporte e uso móvel.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.carimbosDatador} alt="" /></div>
            <h3>Datador</h3>
            <p>Com data e marcação variável.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.carimboPersonalizado} alt="" /></div>
            <h3>Acessórios</h3>
            <p>Tintas, almofadas e resinas para reposição.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('carimbos')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('carimbos', document.title)}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default CarimboAcessorios;